module.exports = __webpack_public_path__ + "img/all2.ec89877e.png";